import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';

/**
 * Lightweight division activity list (recent jobs + optional membership events).
 */
export default function DivisionActivityFeed({
  recentJobs = [],
  title = 'Recent activity',
  emptyText = 'No recent division jobs yet.',
  maxItems = 8,
  tones = {},
}) {
  const T = {
    text: '#e8eaed',
    textMuted: '#9aa0a6',
    border: 'rgba(255,255,255,0.08)',
    surfaceAlt: 'rgba(255,255,255,0.03)',
    mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
    ...tones,
  };

  const items = (Array.isArray(recentJobs) ? recentJobs : []).slice(0, maxItems);

  return (
    <Box sx={{ border: `1px solid ${T.border}`, borderRadius: 1.5, overflow: 'hidden' }}>
      <Box sx={{ px: 2, py: 1.5, borderBottom: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocalShippingOutlined sx={{ fontSize: 16, color: T.textMuted }} />
        <Typography sx={{ fontFamily: T.mono, fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase', color: T.textMuted }}>
          {title}
        </Typography>
      </Box>
      {items.length === 0 ? (
        <Typography sx={{ p: 2, fontFamily: T.mono, fontSize: 13, color: T.textMuted }}>
          {emptyText}
        </Typography>
      ) : (
        <Stack spacing={0} divider={<Box sx={{ borderBottom: `1px solid ${T.border}` }} />}>
          {items.map((job, idx) => {
            const key = job._id || job.jobID || idx;
            const route = `${job.sourceCity || job.source?.city || job.source || '—'} → ${job.destinationCity || job.destination?.city || job.destination || '—'}`;
            return (
              <Box key={key} sx={{ px: 2, py: 1.25, bgcolor: T.surfaceAlt, display: 'flex', gap: 1.5, alignItems: 'center' }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: 13, color: T.text, fontWeight: 600 }} noWrap>
                    {job.driverName || job.driver?.username || job.username || 'Driver'}
                    {job.mine ? ' (you)' : ''}
                  </Typography>
                  <Typography sx={{ fontFamily: T.mono, fontSize: 11, color: T.textMuted }} noWrap>
                    {route}
                  </Typography>
                </Box>
                <Stack alignItems="flex-end" spacing={0.5}>
                  {job.status && <Chip size="small" label={job.status} sx={{ height: 20, fontSize: 10 }} />}
                  <Typography sx={{ fontFamily: T.mono, fontSize: 11, color: T.textMuted }}>
                    {Math.round(job.distanceDriven || job.distanceKm || 0).toLocaleString()} km
                  </Typography>
                </Stack>
              </Box>
            );
          })}
        </Stack>
      )}
    </Box>
  );
}
